import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateUserRequest, IListRolesRequest, IUpdateUserRequest, IUserRole, IUserRoleRequest } from '../models/employee';

export interface IResetPasswordRequest{
  userId: string,
  password: string
}

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  public getUsersRole(id: string){
    return this.http.get<IUserRole[]>(
      `${environment.baseUrl}/users/${id}/roles`
    )
  }

  public updateUsersRoles(id: string, request: IUserRoleRequest){
    return this.http.post<string>(
      `${environment.baseUrl}/users/${id}/roles`,
      request
    )
  }


  getPermissionRoleDetails(userId: string, showRootRoles: boolean = false){
    const request : IListRolesRequest = {
      userId: userId,
      showRootRoles: showRootRoles
    }
    return this.http.post<IUserRole[]>(
      `${environment.baseUrl}/users/listRoles`,
      request
    )
  }

  updateUsersPermissionRole(id: string, request: IUserRole[]){
    return this.http.post<string>(
      `${environment.baseUrl}/users/${id}/roles`,
      request,
      {responseType: 'text' as 'json'}
    )
  }

  resetPassword(request: IResetPasswordRequest){
    return this.http.post<IResetPasswordRequest>(
      `${environment.baseUrl}/users/reset-password`,
      request,
      {responseType: 'text' as 'json'}
    )
  }
}
